var render = function render(){var _vm=this,_c=_vm._self._c;return _vm._m(0)
}
var staticRenderFns = [function (){var _vm=this,_c=_vm._self._c;return _c('section',{staticClass:"flash-loader"},[_c('img',{staticClass:"blink",attrs:{"src":require("../assets/images/R5.svg")}}),_c('div',{staticClass:"loader-msg"},[_vm._v("Match Will Be Live Soon...")])])
}]

export { render, staticRenderFns }